import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon, GiftIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CHECKOUT_URL, PRICE, REGULAR_PRICE, SAVINGS, TOMES_VALUE, BONUSES_VALUE, TOTAL_VALUE } from '../data/offer';
const volumes = ['Volume 1 — Diagnosi Profonda e Onboarding', 'Volume 2 — Il Nucleo: Riscrivere le Credenze', 'Volume 3 — Dall’intuizione all’azione', 'Volume 4 — Il cliente bloccato ⭐', 'Volume 5 — Chiudere bene', 'Volume 6 — La pratica professionale', '23 schede di lavoro WS-01 → WS-23'];
const bonuses = ['Bonus 1 — Kit Documenti del Coach Professionista', 'Bonus 2 — Il Quaderno del Percorso', 'Bonus 3 — La Sessione Conoscitiva Completa', 'Bonus 4 — Il Cruscotto della Pratica', 'Bonus 5 — Avvio Rapido'];
const badges = ['Risparmi ' + SAVINGS, 'Pagamento unico', 'Accesso a vita'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-cream" data-id="element-154" data-mp="3c78ketpaqdy0">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-155" data-mp="3w08g2dow7wd0">
        <h2 id="pricing-heading" className="font-serif font-bold text-ink text-2xl sm:text-4xl text-center" data-id="element-156" data-mp="4svuznkw2yrt">
          Prendi il sistema completo oggi
        </h2>

        <div className="mt-8 rounded-3xl bg-white border-2 border-sage-soft shadow-card p-7 sm:p-10" data-id="element-157" data-mp="erbkjm49pzz7">
          <div className="text-center" data-id="element-158" data-mp="3d97gpojv1ysx">
            <p className="font-serif font-bold text-ink text-xl sm:text-2xl leading-snug" data-id="element-159" data-mp="3daa5nqxmhr67">
              Il Sistema Completo del Coach™ — Edizione Completa
            </p>
            <p className="mt-2 text-ink-soft text-sm sm:text-base" data-id="element-160" data-mp="3n6ljilcv2p2r">
              Tutto quello che serve per condurre un percorso di coaching
              dall&apos;inizio alla fine
            </p>
          </div>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-6 text-left" data-id="element-161" data-mp="2uhenpu4skdl7">
            <div data-id="element-162" data-mp="2zh0yzy127jrd">
              <p className="text-xs uppercase tracking-[0.14em] font-bold text-sage" data-id="element-163" data-mp="2zgiwwkrpubbj">
                I 6 volumi
              </p>
              <ul className="mt-3 space-y-2" data-id="element-164" data-mp="2rf1us36q3k7u">
                {volumes.map(item => <li key={item} className="flex items-start gap-2 text-[14px] text-ink-soft" data-id="element-165" data-mp="2mh8lv2e1cc3v">
                    <CheckIcon className="w-4 h-4 mt-0.5 flex-shrink-0 text-vital" aria-hidden="true" data-id="element-166" data-mp="3164up1nx1t5j" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div data-id="element-167" data-mp="23jpctyrkuthg">
              <p className="text-xs uppercase tracking-[0.14em] font-bold text-terracotta" data-id="element-168" data-mp="23k7exc0x81xa">
                I 5 bonus
              </p>
              <ul className="mt-3 space-y-2" data-id="element-169" data-mp="2idtvbhsh0dc6">
                {bonuses.map(item => <li key={item} className="flex items-start gap-2 text-[14px] text-ink-soft" data-id="element-170" data-mp="2dj6fe7bj8r97">
                    <GiftIcon className="w-4 h-4 mt-0.5 flex-shrink-0 text-terracotta" aria-hidden="true" data-id="element-171" data-mp="3txg4j3nlmk13" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="mt-8 rounded-2xl bg-cream border border-cream-dark px-5 py-4 text-sm text-ink-soft text-center" data-id="element-172" data-mp="5arukcwetbj5">
            I 6 volumi: <strong className="text-ink" data-id="element-173" data-mp="3rgonys3qd4cz">{TOMES_VALUE}</strong> · I
            5 bonus: <strong className="text-ink" data-id="element-174" data-mp="3rirfxhog17kc">{BONUSES_VALUE}</strong> ·
            Valore totale:{' '}
            <strong className="text-ink" data-id="element-175" data-mp="j2y95ujwzagh">{TOTAL_VALUE}</strong>
            <span className="block mt-1" data-id="element-176" data-mp="nywv7bhrsgdq">
              Prezzo regolare:{' '}
              <span className="line-through" data-id="element-177" data-mp="a931aerer5x5">{REGULAR_PRICE}</span>
            </span>
          </div>

          <div className="mt-7 text-center" data-id="element-178" data-mp="e9d97wyrg6en">
            <div className="flex items-end justify-center gap-3" data-id="element-179" data-mp="e8btvgapoxr4">
              <span className="font-serif text-2xl text-ink-muted line-through" data-id="element-180" data-mp="11yobjivre8uw">
                {REGULAR_PRICE}
              </span>
              <span className="font-serif font-black text-6xl sm:text-7xl text-terracotta leading-none" data-id="element-181" data-mp="16sk7ygwdjnny">
                {PRICE}
              </span>
            </div>

            <ul className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-182" data-mp="3a7nto49n572z">
              {badges.map(badge => <li key={badge} className="rounded-full bg-sage-tint text-sage border border-sage-soft px-3.5 py-1.5 text-xs sm:text-sm font-semibold" data-id="element-183" data-mp="359unvcc92f38">
                  {badge}
                </li>)}
            </ul>

            <p className="mt-5 text-xs sm:text-sm text-ink-muted" data-id="element-184" data-mp="3szyjawfab8j5">
              Addebito in euro, IVA inclusa dove applicabile.
            </p>

            <CtaButton href={CHECKOUT_URL} className="mt-3 w-full" data-id="element-185" data-mp="3o5u8g22wegcs">
              Sì, voglio Il Sistema Completo del Coach
            </CtaButton>

            <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs sm:text-sm text-ink-soft font-medium" data-id="element-186" data-mp="kk59f0fgkvb2">
              <li className="flex items-center gap-1.5" data-id="element-187" data-mp="fr3s6lrs4job">
                <LockIcon className="w-4 h-4 text-vital" aria-hidden="true" data-id="element-188" data-mp="1yfwvbk1debo8" />
                Pagamento sicuro
              </li>
              <li className="flex items-center gap-1.5" data-id="element-189" data-mp="23ero9et1xgm2">
                <ZapIcon className="w-4 h-4 text-vital" aria-hidden="true" data-id="element-190" data-mp="27fbl0h9pqi7o" />
                Download immediato
              </li>
              <li className="flex items-center gap-1.5" data-id="element-191" data-mp="2cfpix6hlobrz">
                <ShieldCheckIcon className="w-4 h-4 text-vital" aria-hidden="true" data-id="element-192" data-mp="2he961a7xjtlx" />
                Garanzia 7 giorni
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}